<template>
    <v-dialog v-model="shows" max-width="400" persistent :fullscreen="!$vuetify.breakpoint.lgAndUp">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, disabled }" />
        </template>
        <v-card tile>
            <v-card-title>선택 보내시는분 변경</v-card-title>
            <v-card-text class="pb-0">
                <v-row class="mx-n2">
                    <v-col cols="12" class="pa-2"> <table-sender-summary v-bind="{ selected }" /> </v-col>
                    <v-col cols="12" class="pa-2"> <v-text-field v-model="sender.name" v-bind="{ ...attrs_input, disabled }" label="보내시는분" /> </v-col>
                    <v-col cols="12" class="pa-2"> <v-phone-field v-model="sender.phone" v-bind="{ ...attrs_input, disabled }" :colAttrs="{ class: 'pa-2' }" :rowAttrs="{ class: 'ma-n2' }" label="연락처" /> </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-subheader class="caption">
                    선택된 항목 총
                    <span class="mx-1 text-subtitle-1 font-weight-bold primary--text">
                        {{ selected.length }}
                    </span>
                    건
                </v-subheader>
                <v-spacer />
                <v-btn text color="primary" @click="shows = false">취소</v-btn>
                <v-btn text color="primary" v-bind="{ disabled }" @click="save">변경</v-btn>
            </v-card-actions>
            <v-fade-transition>
                <v-overlay v-show="loading" absolute light color="white">
                    <v-sheet width="240" rounded style="overflow: hidden">
                        <v-progress-linear :value="(updatedLength / selected.length) * 100" height="24">
                            <span> {{ updatedLength }} / {{ selected.length }} </span>
                        </v-progress-linear>
                    </v-sheet>
                </v-overlay>
            </v-fade-transition>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, PURCHASE_ORDER_UPDATE_COLUMN } from "@/assets/variables";

import TableSenderSummary from "./table-sender-summary.vue";
import VPhoneField from "@/components/plugins/vuetify/v-phone-field.vue";

const initSender = () => ({ name: null, phone: null });

export default {
    components: {
        TableSenderSummary,
        VPhoneField,
    },
    props: {
        selected: { type: Array, default: () => [] },
    },
    data: () => ({
        shows: false,
        loading: false,

        sender: initSender(),

        updatedLength: 0,

        attrs_input,
    }),
    computed: {
        disabled() {
            return !this.selected.length;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
        },
    },
    methods: {
        init() {
            this.updatedLength = 0;
            this.sender = initSender();
        },
        async save() {
            if (this.loading) return;
            this.loading = true;

            try {
                let { sender } = this;
                let form = { sender };

                let orders = [];
                for (const { _id } of this.selected) {
                    orders.push((await api.console.shop.purchaseOrders.put({ _id, ...form, updatedColumn: PURCHASE_ORDER_UPDATE_COLUMN.SENDER.value }))?.order);
                    this.updatedLength += 1;
                }
                setTimeout(() => {
                    alert("변경되었습니다");
                    this.$emit("updateItems", orders);
                    this.loading = false;
                    this.shows = false;
                }, 500);
            } finally {
                setTimeout(() => {
                    if (this.loading) this.loading = false;
                }, 500);
            }
        },
    },
};
</script>

<style>
</style>